import { useRef } from 'react'

import { LoginWithUsernameServiceAPI } from '../../services/LoginWithUsernameService/index.api'

const useLoginWithUsernameService = (): LoginWithUsernameServiceAPI => {
   const loginWithUsernameServiceRef = useRef(new LoginWithUsernameServiceAPI())

   return loginWithUsernameServiceRef.current
}

export { useLoginWithUsernameService }
